import React from 'react';
import { Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";


const LegalLayout = (props) => {
    const { pathname } = useLocation();

    const pageTitle = () => {
        if (pathname.includes('legal/privacy-policy')) {
            return 'Privacy Policy'
        } else if (pathname.includes('legal/terms')) {
            return 'Terms'
        } else if (pathname.includes('legal/cookie-policy')) {
            return 'Cookie Policy'
        }
        return 'Legal'
    }

    return (
        <>
            <Helmet>
                <title>{pageTitle()} | Wripple</title>
            </Helmet>
            <Outlet />
        </>
    )
}

export default LegalLayout;